export const FormField = {
  reason: 'reason',
} as const;

export type FormValues = {
  [FormField.reason]: string;
};
